/* eslint-disable no-lonely-if */
/* eslint-disable eqeqeq */
/* eslint-disable no-return-assign */
import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as queryString from 'query-string';
import PropTypes from 'prop-types';

import withAuth from '../hocs/withAuth';
import GlobalSearchWrapper from './GlobalSearch/GlobalSearchWrapper';
import Splash from '../Splash';
import InfoButton from '../InfoButton';
import ActivateUtrNotification from '../ActivateUtrNotification';
import { trackEvent } from '../Analytics/TrackedClick';
import { PopupTypes } from '../../utils/constants';
import Img from '../Img';
import { getClickAttrs } from '../Analytics/gtag';

import { showPopupNew } from '../../actions/popup-actions';
import { fetchPaidHitClubPaymentAccounts } from '../../actions';
import { toggleMenuState } from '../../actions/menu-actions';
import { userIsPaidHitter, userHasActiveClubPower } from '../../utils/user';
import { shouldDisplayActivateUtrNotification, isUtrActivationInProgress, getUserAge, UtrActivationUnderAgeLimit } from '../../utils/activateUtr';
import { clickCategories, clickLocations } from '../../utils/analytics';
import { navigationIDs } from '../Analytics/testIDConfig';
import { paths } from '../../../constants';
import config from '../../../config';
import { sportPreferencePromptStates } from '../../utils/eventConstants';
import UtrAppLogo from './components/UtrAppLogo';
import DesktopLink from './components/DesktopLink';
import DesktopButton from './components/DesktopButton';
import MobileIconButton from './components/MobileIconButton';
import MobilePostButton from './components/MobilePostButton';
import MobileToggleMenu from './components/MobileToggleMenu';
import DesktopIconButton from './components/DesktopIconButton';
import DesktopPostButton from './components/DesktopPostButton';
import DesktopPowerButtons from './components/DesktopPowerButtons';
import DesktopToggleMenu from './components/DesktopToggleMenu';
import { useStatsig } from '../hooks/useStatsig';
import { featureGates } from '../../utils/statsig';
import {
    buildNavClassName,
    buildPlusButtonOptions,
    buildPowerUpgradePopupPayload,
    computeHeaderPosition,
    getSearchUrl,
    getHomeFeedNavStyle,
    getJoinPathName,
    getLoginPathName,
    getMenuOptionPath,
    hasPaidHitPaymentAccountReady,
    isOnTransparentHomeNav,
    isPremiumClubsOrganiser as isPremiumOrganiser,
    showHeaderItemsForUser,
} from './headerUtils';

import styles from './header.scss';

const showButtons = [paths.getRated];

const Header = (props) => {
    const { history, location, isImpersonating } = props;
    const [state, setState] = useState({
        atTop: true,
        fixHeader: false,
        headerMenuOpened: false,
    });
    const globalSearchRef = useRef();

    const header = useSelector(({ header }) => header);
    const auth = useSelector(({ auth }) => auth);
    const search = useSelector(({ search }) => search);
    const messaging = useSelector(({ messaging }) => messaging);
    const activateUtr = useSelector(({ activateUtr }) => activateUtr);
    const dispatch = useDispatch();
    const eventsType = 'events';
    const playersType = 'players';

    const { user } = auth;

    useEffect(() => {
        window.addEventListener('scroll', handlePositionChange, true);
        return () => {
            window.removeEventListener('scroll', handlePositionChange, false);
        };
    }, []);

    const { checkGate } = useStatsig();
    const isCreateEventEnabled = checkGate(featureGates.CREATE_EVENT_PLUS_ICON);

    const paidHitClubMembership = userIsPaidHitter(auth.user);

    useEffect(() => {
        if (paidHitClubMembership?.clubId && !auth.paidHitClubPaymentAccountsLoaded) {
            dispatch(fetchPaidHitClubPaymentAccounts(paidHitClubMembership.clubId));
        }
    }, [dispatch, paidHitClubMembership, auth.paidHitClubPaymentAccountsLoaded]);

    const handlePositionChange = () => {
        const next = computeHeaderPosition({
            scrollY: window.pageYOffset,
            isResetPosition: !!header?.resetPosition,
        });
        setState((prevState) => ({ ...prevState, ...next }));
    };

    const handleLogoClick = (e) => {
        e.preventDefault();

        if (auth?.user) {
            window.open(`${config.marketingAppHost}`, '_blank', 'noopener,noreferrer');
        } else {
            window.location.href = `${config.marketingAppHost}`;
        }
    };

    const closeClickHandler = (url = null) => {
        if (url) {
            history.push(url);
        } else {
            history.goBack();
        }
    };

    const navTo = (to) => {
        history.push(to);
    };

    const MENU_OPTION_TRACK_EVENT = {
        post_a_score: 'Individual Post Score Clicked Segment',
        create_an_event: 'Individual Create Event Clicked Segment',
        create_play: 'Individual Create Play Event Clicked Segment',
        offer_paid_hit: 'Individual Create Play Event Clicked Segment',
        create_paid_hit: 'Individual Create Play Event Clicked Segment',
    };

    const optionSelected = (option) => {
        const eventName = MENU_OPTION_TRACK_EVENT[option.id];
        if (!eventName) {
            return;
        }
        trackEvent(eventName, { pageLocation: clickCategories.HEADER });
        const path = getMenuOptionPath(option.id, { canCreateEvent: auth.user?.canCreateEvent });
        if (path) {
            navTo(path);
        }
    };

    const toggleHeaderMenu = () => {
        setState((prevState) => ({
            ...prevState,
            headerMenuOpened: !prevState.headerMenuOpened,
        }));
    };

    const eventsSearchUrl = getSearchUrl(auth?.feedPreferences, eventsType);
    const playersSearchUrl = getSearchUrl(auth?.feedPreferences, playersType);
    const handlePowerClick = (e) => {
        e.preventDefault();

        if (auth.user?.isPowered) {
            trackEvent('Power Perks Nav Top Power Active Entrypoint Click Segment', {
                page: 'Home',
                button: 'Power Perks',
                action: 'click',
            });
            history.push(paths.powerPerks);
            return;
        }
        trackEvent('Power Perks Nav Top Start Power Button Click Segment', {
            page: 'Home',
            button: 'Start Power',
            action: 'click',
        });
        dispatch(showPopupNew(buildPowerUpgradePopupPayload(location.pathname)));
    };

    const onJoinClick = (ev) => {
        ev.preventDefault();
        const parsed = queryString.parse(location.search);
        const pathName = getJoinPathName({
            parsed,
            eventTargetPathname: ev.target.pathname,
            locationPathname: location.pathname,
        });

        if (isUtrActivationInProgress(activateUtr) && getUserAge(activateUtr) < UtrActivationUnderAgeLimit) {
            dispatch(showPopupNew({
                popup: PopupTypes.ACTIVATE_UTR_UNDER_AGE_POPUP,
                onClosePopup: () => {
                    history.push(pathName);
                },
            }));
        } else {
            history.push(pathName);
        }
    };

    const onLoginClick = (ev) => {
        ev.preventDefault();
        const parsed = queryString.parse(location.search);
        const pathName = getLoginPathName({
            parsed,
            eventTargetPathname: ev.target.pathname,
            locationPathname: location.pathname,
        });
        history.push(pathName);
    };

    const transparent = state.atTop && header.style === 'transparent' && !user;
    const buttons = !showButtons.includes(`/${location.pathname.split('/')[1]}`);
    const userIsPremiumOrganiser = isPremiumOrganiser(user);
    const showHeaderItems = showHeaderItemsForUser(auth.user);
    const displayGlobalSearch = !auth.user || showHeaderItems;
    const hasPaidHitClubMembership = !!paidHitClubMembership;
    const hasPaidHitPaymentAccount = hasPaidHitPaymentAccountReady(auth);
    const isPaidHitter = hasPaidHitClubMembership && hasPaidHitPaymentAccount;

    const plusButtonOptions = buildPlusButtonOptions({
        user: auth.user,
        hasPaidHitClubMembership,
        paidHitClubPaymentAccountsLoaded: auth.paidHitClubPaymentAccountsLoaded,
        hasPaidHitPaymentAccount,
        isPaidHitter,
        isPremiumOrganiser: userIsPremiumOrganiser,
        isCreateEventEnabled,
    });

    const showActivateUtrNotification = shouldDisplayActivateUtrNotification(activateUtr, location.pathname);
    const hasAnsweredSportPreferencePrompt = auth?.user?.sportPreferencePromptState === sportPreferencePromptStates.ANSWERED;
    const navStyle = getHomeFeedNavStyle(isOnTransparentHomeNav({
        authUser: auth.user,
        locationPathname: location.pathname,
        hasAnsweredSportPreferencePrompt,
    }));

    const navClassName = buildNavClassName({
        baseClass: styles.nav,
        headerType: header.type,
        transparent,
        searchIsExpanded: search.isExpanded,
        fixHeader: state.fixHeader,
        showActivateUtrNotification,
        hasUser: !!auth.user,
    });
    const getSelectedMenu = (menu) => {
        return location.search.includes(`type=${menu}`);
    };

    return (
        <div className={`${isImpersonating ? styles.impersonating : ''}`}>
            <nav style={navStyle} className={navClassName} data-testid="header.nav">
                {header.type == 'search' && (
                    <>
                        {showActivateUtrNotification && (
                            <ActivateUtrNotification type={activateUtr.activationType} />
                        )}
                        <div className={styles.desktopHeader}>
                            {auth.user ? (
                                <div className={styles.desktopAuth}>
                                    <UtrAppLogo
                                        onClick={handleLogoClick}
                                    />
                                    <div className={styles.links}>
                                        <DesktopLink
                                            label={'Home'}
                                            to={paths.home}
                                            navId={'home'}
                                            isActive={location.pathname === paths.home}
                                        />
                                        <DesktopLink
                                            label={'Players'}
                                            to={playersSearchUrl}
                                            navId={'players'}
                                            isActive={location.search.includes(`type=${playersType}`)}
                                        />
                                        <DesktopLink
                                            label={'Events'}
                                            to={eventsSearchUrl}
                                            navId={'events'}
                                            isActive={location.search.includes(`type=${eventsType}`)}
                                        />
                                        <DesktopLink
                                            label={'College Corner'}
                                            to={paths.collegeCorner}
                                            navId={'collegeCorner'}
                                            isActive={location.pathname === paths.collegeCorner}
                                        />
                                    </div>
                                    <div className={styles.search}>
                                        <GlobalSearchWrapper onRef={ref => (globalSearchRef.current = ref)} />
                                    </div>
                                    {buttons && (
                                        <div className={styles.rightSectionAuth}>
                                            {showHeaderItems && (
                                                <div className={styles.iconButtons}>
                                                    <DesktopIconButton
                                                        label={'Messages'}
                                                        to={paths.inbox}
                                                        navId={'messages'}
                                                        icon={'/img/icons/message.svg'}
                                                        notificationDot={messaging.headerUnreadNotification}
                                                    />
                                                    {plusButtonOptions?.length > 0 && (
                                                        <DesktopPostButton
                                                            plusButtonOptions={plusButtonOptions}
                                                            optionSelected={optionSelected}
                                                            toggleHeaderMenu={toggleHeaderMenu}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                            {auth.user?.onboardingCompleted && (
                                                <DesktopPowerButtons
                                                    isPowered={auth.user?.isPowered}
                                                    hasPastDueSubscription={auth.user?.hasPastDueSubscription}
                                                    hasActiveClubPower={userHasActiveClubPower(auth.user)}
                                                    isActive={location.pathname == paths.powerPerks}
                                                    onClick={handlePowerClick}
                                                />
                                            )}
                                            <DesktopToggleMenu
                                                authUser={auth?.user}
                                                onClick={() => dispatch(toggleMenuState())}
                                            />
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className={styles.desktopUnauth}>
                                    <div className={styles.leftSection}>
                                        <UtrAppLogo
                                            onClick={handleLogoClick}
                                        />
                                        <div className={styles.links}>
                                            <DesktopLink
                                                label={'Players'}
                                                to={playersSearchUrl}
                                                navId={'players'}
                                                isActive={location.search.includes(`type=${playersType}`)}
                                            />
                                            <DesktopLink
                                                label={'Events'}
                                                to={eventsSearchUrl}
                                                navId={'events'}
                                                isActive={location.search.includes(`type=${eventsType}`)}
                                            />
                                        </div>
                                    </div>
                                    <div className={styles.search}>
                                        <GlobalSearchWrapper onRef={ref => (globalSearchRef.current = ref)} />
                                    </div>
                                    {buttons && (
                                        <div className={styles.rightSection}>
                                            <DesktopButton
                                                label="Sign In"
                                                onClick={onLoginClick}
                                                to={paths.login}
                                                navId={'signIn'}
                                                className={`${styles.navLink} text-uppercase text-black fw600`}
                                                data-testid="header.sign-in-btn"
                                            />
                                            <DesktopButton
                                                label="Join"
                                                onClick={onJoinClick}
                                                to={paths.join}
                                                navId={'join'}
                                                className={`btn btn-primary text-uppercase ${styles.joinBtn}`}
                                                data-testid="header.join-btn"
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className={styles.mobileHeader}>
                            {auth.user ? (
                                <div className={styles.mobileAuth}>
                                    <div className={styles.mobileTopRow}>
                                        <UtrAppLogo
                                            onClick={handleLogoClick}
                                        />
                                        <div className={styles.mobileTopRowRightSection}>
                                            {displayGlobalSearch && (
                                                <GlobalSearchWrapper onRef={ref => (globalSearchRef.current = ref)} />
                                            )}
                                            {plusButtonOptions && plusButtonOptions.length > 0 && (
                                                <MobilePostButton
                                                    plusButtonOptions={plusButtonOptions}
                                                    optionSelected={optionSelected}
                                                    toggleHeaderMenu={toggleHeaderMenu}
                                                    selected={state.headerMenuOpened}
                                                    iconUnselected={'/img/v4/post-unselected.svg'}
                                                    iconSelected={'/img/v4/post-selected.svg'}
                                                />
                                            )}
                                            <MobileToggleMenu
                                                onClick={() => dispatch(toggleMenuState())}
                                                authUser={auth?.user}
                                            />
                                        </div>
                                    </div>
                                    <div className={styles.mobileBottomRow}>
                                        <MobileIconButton
                                            label={'Home'}
                                            navId={'mobileHome'}
                                            to={paths.home}
                                            selected={state.headerMenuOpened && location.pathname === paths.home}
                                            iconUnselected={'/img/v4/home-unselected.svg'}
                                            iconSelected={'/img/v4/home-selected.svg'}
                                        />
                                        <MobileIconButton
                                            label={'Players'}
                                            navId={'mobilePlayers'}
                                            to={playersSearchUrl}
                                            selected={!state.headerMenuOpened && getSelectedMenu(playersType)}
                                            iconUnselected={'/img/v4/players-unselected.svg'}
                                            iconSelected={'/img/v4/players-selected.svg'}
                                        />
                                        <MobileIconButton
                                            label={'Events'}
                                            navId={'mobileEvents'}
                                            to={eventsSearchUrl}
                                            selected={!state.headerMenuOpened && getSelectedMenu(eventsType)}
                                            iconUnselected={'/img/v4/events-unselected.svg'}
                                            iconSelected={'/img/v4/events-selected.svg'}
                                        />
                                        <MobileIconButton
                                            label={'College Corner'}
                                            navId={'collegeCorner'}
                                            to={paths.collegeCorner}
                                            selected={location.pathname === paths.collegeCorner}
                                            iconUnselected={'/img/v4/icon-header-college-corner-unselected.svg'}
                                            iconSelected={'/img/v4/icon-header-college-corner-selected.svg'}
                                        />
                                        <MobileIconButton
                                            label={'Messages'}
                                            to={paths.inbox}
                                            navId={'messagesMobile'}
                                            iconUnselected={'/img/v4/message-unselected.svg'}
                                            iconSelected={'/img/v4/message-selected.svg'}
                                            notificationDot={messaging.headerUnreadNotification}
                                            selected={!state.headerMenuOpened && location.pathname === paths.inbox}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className={styles.mobileUnauth}>
                                    <div className={styles.mobileTopRow}>
                                        <UtrAppLogo
                                            onClick={handleLogoClick}
                                        />
                                        <div className={styles.rightSection}>
                                            <MobileIconButton
                                                label={'Players'}
                                                navId={'mobilePlayers'}
                                                to={paths.searchPlayers}
                                                selected={!state.headerMenuOpened && getSelectedMenu('players')}
                                                iconUnselected={'/img/v4/players-unselected.svg'}
                                                iconSelected={'/img/v4/players-selected.svg'}
                                            />
                                            <MobileIconButton
                                                label={'Events'}
                                                navId={'mobileEvents'}
                                                to={paths.searchEvents}
                                                selected={!state.headerMenuOpened && getSelectedMenu('events')}
                                                iconUnselected={'/img/v4/events-unselected.svg'}
                                                iconSelected={'/img/v4/events-selected.svg'}
                                            />
                                            {displayGlobalSearch && (
                                                <GlobalSearchWrapper onRef={ref => (globalSearchRef.current = ref)} />
                                            )}
                                            <MobileToggleMenu
                                                onClick={() => dispatch(toggleMenuState())}
                                                authUser={auth?.user}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )}
                {header.type == 'title' && (
                    <div className="container" style={{ position: 'relative' }}>
                        <div className="col d-flex justify-content-center align-items-center">
                            <div
                                className="close-area"
                                onClick={() => closeClickHandler(header.closeHandleClick)}
                                {...getClickAttrs({
                                    category: clickCategories.HEADER,
                                    context: `Close Icon`,
                                    location: clickLocations.HEADER_CTA,
                                    testid: `${navigationIDs.closeIcon.component}-${navigationIDs.closeIcon.location}-${navigationIDs.closeIcon.id}`,
                                })}
                            >
                                <Img className="close-icon" src="/img/icons/close-icon-lg.svg" />
                            </div>
                            {header.title && (
                                <div className="title-span text-center ml40 mr40">
                                    <span className="text-medium title text-uppercase text-dark " data-testid="page-header.title">
                                        {header.title} {header.titleInfo && (<InfoButton hoverText={header.titleInfo} />)}
                                    </span>
                                    {header.subTitle && (
                                        <div className="sub-title text-center text-14">
                                            {header.subTitle} {header.subTitleInfo && (<InfoButton hoverText={header.subTitleInfo} />)}
                                        </div>
                                    )}
                                </div>
                            )}
                            <div>
                                <GlobalSearchWrapper onRef={ref => (globalSearchRef.current = ref)} />
                            </div>
                        </div>
                    </div>
                )}
            </nav>
            <Splash />
        </div>

    );
};

Header.propTypes = {
    history: PropTypes.instanceOf(Object).isRequired,
    location: PropTypes.instanceOf(Object).isRequired,
    isImpersonating: PropTypes.bool,
};

Header.defaultProps = {
    isImpersonating: false,
};

export default withAuth(withRouter(Header));
